var component = require('../../../lib/js/component.js');

function CommunityLeadForm() {
    this.initialize = function (element) {
        var _this = this;
        _this.$communityLeadFormGetDirectionsCta = _this.$element.find(".CommunityLeadForm__getDirections-cta");
        _this.$communityLeadFormPhoneNumberCta = _this.$element.find(".CommunityLeadForm__phoneNumber-cta");
        _this.$element.on("click", ".CommunityLeadForm__availableHoursToggle", function (event) {
            var seeHoursLabel = _this.$element.find(".CommunityLeadForm__seeHoursLabel");
            var closeHoursLabel = _this.$element.find(".CommunityLeadForm__closeHoursLabel");
            var hoursList = _this.$element.find(".CommunityLeadForm__hours-info-container");
            seeHoursLabel.toggleClass("d-none");
            closeHoursLabel.toggleClass("d-inline");
            hoursList.toggle("fast");
        });
        var communityId = _this.$element.find("input[name=CommunityIds]");
        var directionsMapModalVersion = _this.find("form[name=CommunityLeadForm]").data("directionsMapVersion")
        if (communityId && _this.$communityLeadFormGetDirectionsCta) {
            _this.$communityLeadFormGetDirectionsCta.attr('data-target', "." + directionsMapModalVersion + "[data-community-id='" + communityId.val() + "']");
        }

        if (_this.$communityLeadFormPhoneNumberCta) {
            var phoneNumber = _this.$communityLeadFormPhoneNumberCta.data("phone");
            _this.$communityLeadFormPhoneNumberCta.attr('href', 'tel:' + phoneNumber);
        }
        var errorContainer = element.querySelector("#form-error");
        var errorText = errorContainer.querySelector(".error-target");

        this.updateErrorState = function () {

            var allInputs = element.querySelectorAll("input");
            for (var i = 0; i < allInputs.length; i++) {
                allInputs[i].removeAttribute("aria-describedby");
                allInputs[i].removeAttribute("aria-invalid");
            }

            var firstInvalid = null;
            for (var j = 0; j < allInputs.length; j++) {
                if (!allInputs[j].checkValidity()) {
                    firstInvalid = allInputs[j];
                    break;
                }
            }

            errorText.textContent = firstInvalid.validationMessage;
            firstInvalid.setAttribute("aria-describedby", "form-error");
            firstInvalid.setAttribute("aria-invalid", "true");
        };

        var inputs = element.querySelectorAll("input");

        for (var i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener("blur", function () {
                _this.updateErrorState();
            });
        }
        
    }
}

module.exports = component(CommunityLeadForm);